import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Cookies from "js-cookie";
import endpoints from "../../config/endpoints";

// Images still on their way to the server. Until an upload finishes the
// editor holds the image without a src, and a form saved in that window stores
// an empty <img> that the editor drops on the next load - the image seems to
// save and then vanishes. Forms check this before saving.
let pendingUploads = 0;

export const editorUploadsPending = () => pendingUploads > 0;

export const EDITOR_UPLOAD_PENDING_MESSAGE =
  "آپلود تصویر توضیحات هنوز تمام نشده است. لطفا چند لحظه صبر کنید و دوباره ذخیره کنید.";

/**
 * Uploads images pasted, dropped or inserted into the editor to the backend
 * and embeds the returned url. The classic build ships the image toolbar
 * button but no upload adapter, so without this images cannot be added.
 */
class UploadAdapter {
  private loader: any;
  private controller = new AbortController();

  constructor(loader: any) {
    this.loader = loader;
  }

  async upload() {
    pendingUploads++;
    try {
      return await this.send();
    } finally {
      pendingUploads--;
    }
  }

  private async send() {
    const file = await this.loader.file;
    const body = new FormData();
    body.append("upload", file);

    const response = await fetch(endpoints.media.editor, {
      method: "POST",
      headers: { Authorization: `Bearer ${Cookies.get("token") || ""}` },
      body,
      signal: this.controller.signal,
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok || !result?.data?.url) {
      throw new Error("آپلود تصویر ناموفق بود");
    }
    return { default: result.data.url };
  }

  abort() {
    this.controller.abort();
  }
}

function UploadAdapterPlugin(editor: any) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader: any) =>
    new UploadAdapter(loader);
}

/** Rich text (HTML) field; the storefront renders its output as-is. */
const RichTextEditor = ({
  value,
  onChange,
}: {
  value?: string;
  onChange: (html: string) => void;
}) => (
  <div className="ckeditorWrapper dirRtl">
    <CKEditor
      editor={ClassicEditor as any}
      data={value || ""}
      config={{
        language: { ui: "fa", content: "fa" },
        extraPlugins: [UploadAdapterPlugin],
      }}
      onChange={(_event, editor) => onChange(editor.getData())}
    />
  </div>
);

export default RichTextEditor;
